import ConferenceLayoutStyleComponent from "../../../containers/components/eucrm-layout-style.component";
import ConferenceHeader from "../../../components/header/eucrm-header";

type headerBanner = {
    bannerImage: string,
    headerText: string,
    topCommonMesage: string,
    mobileBanner: string
}
const Convergence2023Banner = (props: headerBanner ) => {
  return (
    <>
      <ConferenceLayoutStyleComponent />
      <ConferenceHeader />

      <div className="head-message">RAPS European Clinical, Risk, and Postmarket Surveillance Conference | 23-24 October 2024 | Preconference Workshop 22 October</div>
      <div id="header-image" className="header-image">
          <img src={props.mobileBanner} alt="" className="mobile-image" />
          <div className="top-text" dangerouslySetInnerHTML={{ __html: props.headerText }}></div>
      </div>
             
      <div dangerouslySetInnerHTML={{ __html: props.topCommonMesage }}></div>
      <div className="bottom-text" dangerouslySetInnerHTML={{ __html: props.headerText }}></div>
      <style>
        {`
           @media(min-width: 1024px){
            .header-image{
                background-image: url( ${props.bannerImage});
            }
          
            }
            @media(min-width: 1024px){
                .mobile-image{
                    display: none;
                }
            }
            @media(max-width: 1024px){
                .top-text{
                    display: none;
                } 
            }
            @media(min-width: 1025px){
                .bottom-text{
                    display: none;
                }
            }
            .head-message {
                text-align: center;
                font-weight: bold;
                color: white;
                background: #4BA33A;
                padding: 13px 0;
                font-size: 126%;
                margin: 0;
            }
            @media(max-width: 768px){
              .head-message { display: none; }
            }
            
        `}
      </style>
  </>
  )
}

export default Convergence2023Banner